import { render } from "./DarkTablePage.vue?vue&type=template&id=f7e155b4"
import script from "./DarkTablePage.vue?vue&type=script&lang=js"
export * from "./DarkTablePage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__